import { ChangeDetectorRef, Directive, inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { GpuFormFieldAppearance } from '@geneplanet/ngx-ui/src/lib/form-field';
import { AnalyticsService } from '@geneplanet/ngx-utils/src/lib/analytics';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Subject } from 'rxjs';
import {
  AnalysesResultDetails,
  MeasurementConfiguration,
} from 'src/app/analyses/interfaces/analyses.types';
import { AnalyticsFormKey } from 'src/app/analyses/interfaces/analytics-form-key.interface';
import { ngbDateToISO } from 'src/app/shared/util/date-util';
import {
  ErrorResponse,
  MeasurementAnalysisResult,
} from '../interfaces/measurement.interface';

@UntilDestroy()
@Directive({
  selector: '[appMeasurementAddBase]',
})
export class MeasurementAddBaseDirective {
  public formFieldAppearance: GpuFormFieldAppearance;
  public submitted = new Subject<void>();
  public configuration!: MeasurementConfiguration;

  public analysisResult: MeasurementAnalysisResult;
  public detailedResult: AnalysesResultDetails;
  protected error: ErrorResponse = null;

  protected form: FormGroup;
  // This is for analytics only
  protected get formName(): string {
    return `analyses-${this.editMode ? 'edit' : 'add'}`;
  }

  protected analyticsService = inject(AnalyticsService);
  private cdRef = inject(ChangeDetectorRef);

  public get editMode(): boolean {
    return !!this.analysisResult;
  }

  public trackInput(event: any, id: string | undefined): void {
    this.analyticsService.trackFormValue(
      this.formName,
      AnalyticsFormKey.value,
      { value: this.form.get(event.target.name).value },
      this.configuration.id,
      id
    );
  }

  public init(): void {
    this.updateValidators();

    this.fillDefaultForm();

    if (this.editMode) {
      this.fillForm();
    }

    this.cdRef.markForCheck();

    if (this.form.controls.date) {
      this.form.controls.date.valueChanges
        .pipe(untilDestroyed(this))
        .subscribe(() =>
          this.analyticsService.trackFormValue(
            this.formName,
            'date',
            { value: ngbDateToISO(this.form.controls.date.value) },
            this.configuration.id
          )
        );
    }
  }

  public setError(error: ErrorResponse | null) {
    this.error = error;
    this.cdRef.markForCheck();
  }

  // This is for default values that need to be inserted (when not on edit)
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  protected fillDefaultForm() {}

  // This is for values when editing form
  protected fillForm() {
    throw new Error('Method not implemented.');
  }

  protected updateValidators() {
    throw new Error('Method not implemented.');
  }
}
